import { getSmsBalance } from '../services';
import { formatDate } from '@/utilities/formatters';
import { dateTimeCompleteFormat } from '@/utilities/constants';
export const fetchSmsBalance = () => {
    return getSmsBalance()
        .then(response => formatResponse(response.data))
        .catch(() => ({
        success: false,
        balance: 0,
        date: '',
    }));
};
const formatResponse = (response) => {
    return {
        success: response.success,
        balance: response.data?.balance || 0,
        date: formatDate(response.data.date, dateTimeCompleteFormat),
    };
};
